// Date formatting utilities

export function formatDateTime(isoString, includeSeconds = false) {
  if (!isoString) return '';
  const date = new Date(isoString);
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    ...(includeSeconds && { second: '2-digit' })
  };
  return date.toLocaleString('en-AU', options);
}
